if (!customElements.get('l20-twelve-tabs')) {
  class L20TwelveTabs extends HTMLElement {
    connectedCallback() {
      this.carousel = this.querySelector('[data-l20-twelve-carousel]');
      this.slidesTrack = this.querySelector('.l20-twelve-tabs__slides');
      this.slides = [...this.querySelectorAll('[data-l20-twelve-slide]')];
      this.previousButton = this.querySelector('[data-l20-twelve-previous]');
      this.nextButton = this.querySelector('[data-l20-twelve-next]');
      this.currentNumber = this.querySelector('[data-l20-twelve-current]');
      this.liveRegion = this.querySelector('[data-l20-twelve-live]');
      this.currentIndex = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
      this.pointerStart = null;

      if (!this.carousel || !this.slides.length) return;

      this.handleClick = this.handleClick.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);
      this.handlePointerDown = this.handlePointerDown.bind(this);
      this.handlePointerUp = this.handlePointerUp.bind(this);
      this.handlePointerCancel = this.handlePointerCancel.bind(this);
      this.handleBlockSelect = this.handleBlockSelect.bind(this);
      this.handleViewportChange = this.handleViewportChange.bind(this);
      this.desktopMedia = window.matchMedia('(min-width: 769px)');

      this.addEventListener('click', this.handleClick);
      this.carousel.addEventListener('keydown', this.handleKeydown);
      this.carousel.addEventListener('pointerdown', this.handlePointerDown);
      this.carousel.addEventListener('pointerup', this.handlePointerUp);
      this.carousel.addEventListener('pointercancel', this.handlePointerCancel);
      this.addEventListener('shopify:block:select', this.handleBlockSelect);
      this.desktopMedia.addEventListener('change', this.handleViewportChange);
      window.addEventListener('resize', this.handleViewportChange);

      this.showSlide(this.currentIndex, false);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      this.carousel?.removeEventListener('keydown', this.handleKeydown);
      this.carousel?.removeEventListener('pointerdown', this.handlePointerDown);
      this.carousel?.removeEventListener('pointerup', this.handlePointerUp);
      this.carousel?.removeEventListener('pointercancel', this.handlePointerCancel);
      this.removeEventListener('shopify:block:select', this.handleBlockSelect);
      this.desktopMedia?.removeEventListener('change', this.handleViewportChange);
      window.removeEventListener('resize', this.handleViewportChange);
    }

    handleClick(event) {
      if (event.target.closest('[data-l20-twelve-previous]')) {
        this.showSlide(this.currentIndex - 1, true);
      }

      if (event.target.closest('[data-l20-twelve-next]')) {
        this.showSlide(this.currentIndex + 1, true);
      }
    }

    handleKeydown(event) {
      if (event.target.closest('a, button, input, select, textarea') && event.target !== this.carousel) return;

      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        this.showSlide(this.currentIndex - 1, true);
      }

      if (event.key === 'ArrowRight') {
        event.preventDefault();
        this.showSlide(this.currentIndex + 1, true);
      }

      if (event.key === 'Home') {
        event.preventDefault();
        this.showSlide(0, true);
      }

      if (event.key === 'End') {
        event.preventDefault();
        this.showSlide(this.slides.length - 1, true);
      }
    }

    handlePointerDown(event) {
      if (event.pointerType === 'mouse' || event.target.closest('button, a')) return;
      this.pointerStart = { x: event.clientX, y: event.clientY, id: event.pointerId };
    }

    handlePointerUp(event) {
      if (!this.pointerStart || event.pointerId !== this.pointerStart.id) return;

      const deltaX = event.clientX - this.pointerStart.x;
      const deltaY = event.clientY - this.pointerStart.y;
      this.pointerStart = null;

      if (Math.abs(deltaX) < 48 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
      this.showSlide(this.currentIndex + (deltaX < 0 ? 1 : -1), true);
    }

    handlePointerCancel() {
      this.pointerStart = null;
    }

    handleBlockSelect(event) {
      const slide = event.target.closest('[data-l20-twelve-slide]');
      if (!slide || !this.contains(slide)) return;
      this.showSlide(Number.parseInt(slide.dataset.slideIndex, 10), false);
    }

    handleViewportChange() {
      this.showSlide(this.currentIndex, false);
    }

    showSlide(index, announce) {
      if (!this.slides.length || Number.isNaN(index)) return;

      const normalizedIndex = (index + this.slides.length) % this.slides.length;
      this.currentIndex = normalizedIndex;
      const isDesktop = this.desktopMedia.matches;

      this.slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === normalizedIndex;
        slide.hidden = isDesktop ? false : !isActive;
        slide.setAttribute('aria-hidden', String(!isActive));
        slide.classList.toggle('is-active', isActive);
      });

      if (this.slidesTrack) {
        const slideWidth = this.slides[0]?.getBoundingClientRect().width || 0;
        const trackStyles = window.getComputedStyle(this.slidesTrack);
        const trackGap = Number.parseFloat(trackStyles.columnGap || trackStyles.gap) || 0;
        const desktopTranslate = normalizedIndex * -(slideWidth + trackGap);
        this.slidesTrack.style.transform = isDesktop
          ? `translate3d(${desktopTranslate}px, 0, 0)`
          : '';
      }

      if (this.currentNumber) this.currentNumber.textContent = String(normalizedIndex + 1);

      if (announce && this.liveRegion) {
        this.liveRegion.textContent = `Review ${normalizedIndex + 1} of ${this.slides.length}`;
      }
    }
  }

  customElements.define('l20-twelve-tabs', L20TwelveTabs);
}
